import gql from "graphql-tag";

export const SEARCH_COMPONENTS = gql`
  query searchComponents($idValue: String!) {
    SearchComponents(title: $idValue) {
      id
      title
    }
  }
`;

export const COMMON_PROPS_COMPONENTS = `
  id
  title
  subtitle
  version
  lastModifiedDate { formatted },
  isArchived,
  file {
    id,
    uri,
    fileName,
    mimeType,
    fileType,
    size,
    bitDepth,
    samplingRate
  }
  uploader {
    id 
    accountId
  }
  __typename
`;

export const COMPONENT_COMMENTS_PROPS = `
  comments {
    id,
    text,
    creationDate {
      formatted
    },
    lastModifiedDate { formatted },
    author {
      id,
      accountId,
      authStatus,
      fullName,
      imageDepictions {
      id,
      title,
      type,
      thumbnail { 
        id, 
        file {
          mimeType, 
          uri 
          }
        }
      }
      __typename
    }
  }
`;

export const COMPONENT_SHARED_PROPS = `
  sharedComponents{
    uri,
    status,
    accessCount,
    lastAccessedDate { formatted },
    playCount,
    lastPlayedDate { formatted },
    downloadCount,
    lastDownloadedDate { formatted },
    creator{
      id,
      fullName,
      imageDepictions {
        id,
        title,
        type,
        thumbnail { 
          id, 
          file {
            mimeType, 
            uri 
          }
        }
      }
    },
  },
`;

export const COMPONENT_CONTRIBUTIONS_PROPS = `
  contributions {
    id,
    role,
    isArchived,
    contributor {
      id,
      accountId,
      authStatus,
      fullName,
      imageDepictions {
        id,
        title,
        type,
        thumbnail { 
          id, 
          file { 
            mimeType,
            uri 
          }
        }
      }
      __typename
    }
  }
  isContributionOf {
    id,
    role,
    isArchived
    contributor {
      id,
      accountId,
      authStatus,
      fullName,
      imageDepictions {
        id,
        title,
        type,
        thumbnail { 
          id, 
          file { 
            mimeType,
            uri 
          }
        }
      }
      __typename
    }
  }
`;

export const COMPONENT_IS_VERSION_PROPS = `
  isVersionOf {
    id
    project {
      id
    }
  }
`;

export const RECORDING_PROPS = `
          id
          title,
          subtitle,
          url,
          version,
          isArchived,
          keySignature,
          tempo,
          file {
              id,
              uri,
              fileName,
              mimeType,
              fileType,
              size,
              bitDepth,
              samplingRate
          }
          creationDate {
            formatted
          },
          lastModifiedDate { formatted },
          comments {
            id,
            text,
            creationDate {
              formatted
            },
            lastModifiedDate { formatted },
            author {
              id,
              accountId,
              authStatus,
              fullName,
              imageDepictions {
              id,
              title,
              type,
              thumbnail { 
                id, 
                file {
                  mimeType, 
                  uri 
                  }
                }
              }
              __typename
            }
          }
          sharedComponents{
            uri,
            status,
            accessCount,
            lastAccessedDate { formatted },
            playCount,
            lastPlayedDate { formatted },
            downloadCount,
            lastDownloadedDate { formatted },
            creator{
              id,
              fullName,
              imageDepictions {
                id,
                title,
                type,
                thumbnail { 
                  id, 
                  file {
                    mimeType, 
                    uri 
                  }
                }
              }
            },
          },
          contributions {
            id,
            role,
            isArchived,
            contributor {
              id,
              accountId,
              authStatus,
              fullName,
              imageDepictions {
                id,
                title,
                type,
                thumbnail { 
                  id, 
                  file { 
                    mimeType,
                    uri 
                  }
                }
              }
              __typename
            }
          }
          isContributionOf {
            id,
            role,
            isArchived
            contributor {
              id,
              accountId,
              authStatus,
              fullName,
              imageDepictions {
                id,
                title,
                type,
                thumbnail { 
                  id, 
                  file { 
                    mimeType,
                    uri 
                  }
                }
              }
              __typename
            }
          }
          work {
            id,
            contributions {
              id,
              role,
              isArchived,
              contributionsOf {
                id
              }
              contributor {
                id,
                fullName,
                accountId,
                authStatus,
                imageDepictions {
                  id,
                  thumbnail { 
                    id, 
                    file { 
                      mimeType,
                      uri 
                    }
                  }
                }
              }
            }
          }
          isVersionOf {
            id
            project { 
              id
            }
          }
          __typename,
`;

export const SOURCE_FILE_PROPS = `
          id
          title,
          subtitle,
          url,
          version,
          isArchived,
          software,
          keySignature,
          tempo,
          sharedComponents{
            uri,
            status,
            accessCount,
            lastAccessedDate { formatted },
            playCount,
            lastPlayedDate { formatted },
            downloadCount,
            lastDownloadedDate { formatted },
            creator{
              id,
              fullName,
              imageDepictions {
                id,
                title,
                type,
                thumbnail { 
                  id, 
                  file {
                    mimeType, 
                    uri 
                  }
                }
              }
            },
          },
          file {
              id,
              uri,
              fileName,
              mimeType,
              fileType,
              size,
              bitDepth,
              samplingRate
          }
          creationDate {
            formatted
          },
          lastModifiedDate { formatted },
          comments {
            id,
            text,
            creationDate {
              formatted
            },
            lastModifiedDate { formatted },
            author {
              id,
              accountId,
              authStatus,
              fullName,
              imageDepictions {
              id,
              title,
              type,
              thumbnail { 
                id, 
                file {
                  mimeType, 
                  uri 
                  }
                }
              }
              __typename
            }
          }
          contributions {
            id,
            role,
            isArchived,
            contributor {
              id,
              accountId,
              authStatus,
              fullName,
              imageDepictions {
                id,
                title,
                type,
                thumbnail { 
                  id, 
                  file { 
                    mimeType,
                    uri 
                  }
                }
              }
              __typename
            }
          }
          isContributionOf {
            id,
            role,
            isArchived
            contributor {
              id,
              accountId,
              authStatus,
              fullName,
              __typename,              imageDepictions {
                id,
                title,
                type,
                thumbnail { 
                  id, 
                  file { 
                    mimeType,
                    uri 
                  }
                }
              }
            }
          }
          isVersionOf {
            id
            project { 
              id
            }
          }
          __typename,
`;

export const GENERIC_PROPS = `
          id
          title,
          subtitle,
          url,
          version,
          isArchived,
          file {
              id,
              uri,
              fileName,
              mimeType,
              fileType,
              size,
              bitDepth,
              samplingRate
          }
          creationDate {
            formatted
          },
          lastModifiedDate { 
            formatted 
          },
          __typename,
`;

const CONTRIBUTOR_MIN_PROPS = `
contributors {
  id
  fullName
  profilePictureUri
}
`;

export const GET_COMPONENTS_OF_PROJECT = gql`
query getProjectsComponents(
    $personId: ID!,
    $projectId: ID!,
    $sharedComponentStatus: SharedComponentStatus
  ) {
  Project(
    personId: $personId,
    projectId: $projectId,
  ) {
    id,
    title,
    hasArchivedComponents,
    components {
      componentGroup,
      componentGroupOrderWeight,
      componentOrderWeight,
      component {
        ...on Recording {
          ${COMMON_PROPS_COMPONENTS}
          ${COMPONENT_IS_VERSION_PROPS}
          creationDate {
            formatted
          }
          numberOfComments
          numberOfSharedComponents(status: $sharedComponentStatus)
          uploader {
              id 
              accountId
          }
          ${CONTRIBUTOR_MIN_PROPS}
          versions: versionsInProject {
            ...on Recording {
              ${COMMON_PROPS_COMPONENTS}
              ${COMPONENT_IS_VERSION_PROPS}
              creationDate {
                formatted
              }
              numberOfComments
              numberOfSharedComponents(status: $sharedComponentStatus)
              uploader {
              id 
              accountId
          }
              ${CONTRIBUTOR_MIN_PROPS}
            }
          }
        }
        ...on SourceFile {
          ${COMMON_PROPS_COMPONENTS}
          ${COMPONENT_IS_VERSION_PROPS}
          creationDate {
            formatted
          }
          numberOfComments
          numberOfSharedComponents(status: $sharedComponentStatus)
          uploader {
              id 
              accountId
          }
          ${CONTRIBUTOR_MIN_PROPS}
          versions: versionsInProject {
            ...on SourceFile {
              ${COMMON_PROPS_COMPONENTS}
              ${COMPONENT_IS_VERSION_PROPS}
              creationDate {
                formatted
              }
              numberOfComments
              numberOfSharedComponents(status: $sharedComponentStatus)
              uploader {
              id 
              accountId
          }
              ${CONTRIBUTOR_MIN_PROPS}
            }
          }
        }
        ...on Video {
          ${COMMON_PROPS_COMPONENTS}
          ${COMPONENT_IS_VERSION_PROPS}
          creationDate {
            formatted
          }
          numberOfComments
          numberOfSharedComponents(status: $sharedComponentStatus)
          uploader {
              id 
              accountId
          }
          ${CONTRIBUTOR_MIN_PROPS}
          work {
            id
          }
          versions: versionsInProject {
            ${COMMON_PROPS_COMPONENTS}
            ${COMPONENT_IS_VERSION_PROPS}
            creationDate {
              formatted
            }
            numberOfComments
            numberOfSharedComponents(status: $sharedComponentStatus)
            uploader {
              id 
              accountId
          }
            ${CONTRIBUTOR_MIN_PROPS}
            ...on Video {
              work {
                id
              }
            }
          }
        }
        ...on Image {
          ${COMMON_PROPS_COMPONENTS}
          ${COMPONENT_IS_VERSION_PROPS}
          creationDate {
            formatted
          }
          numberOfComments
          numberOfSharedComponents(status: $sharedComponentStatus)
          uploader {
              id 
              accountId
          }
          ${CONTRIBUTOR_MIN_PROPS}
          versions: versionsInProject {
            ${COMMON_PROPS_COMPONENTS}
            ${COMPONENT_IS_VERSION_PROPS}
            creationDate {
              formatted
            }
            numberOfComments
            numberOfSharedComponents(status: $sharedComponentStatus)
            uploader {
              id 
              accountId
          }
            ${CONTRIBUTOR_MIN_PROPS}
          }
        }
        ...on Text {
          ${COMMON_PROPS_COMPONENTS}
          ${COMPONENT_IS_VERSION_PROPS}
          creationDate {
            formatted
          }
          numberOfComments
          numberOfSharedComponents(status: $sharedComponentStatus)
          uploader {
              id 
              accountId
          }
          ${CONTRIBUTOR_MIN_PROPS}
          versions: versionsInProject {
            ${COMMON_PROPS_COMPONENTS}
            ${COMPONENT_IS_VERSION_PROPS}
            creationDate {
              formatted
            }
            numberOfComments
            numberOfSharedComponents(status: $sharedComponentStatus)
            ${CONTRIBUTOR_MIN_PROPS}
            uploader {
              id 
              accountId
          }
          }
        }
      }
    }
  }
}
`;

export const GET_ARCHIVED_COMPONENTS_OF_PROJECT = gql`
query getProjectsArchivedComponents(
    $personId: ID!,
    $projectId: ID!,
  ) {
  Project(
    personId: $personId,
    projectId: $projectId,
  ) {
    id,
    title,
    archivedComponents {
      componentGroup,
      componentGroupOrderWeight,
      componentOrderWeight,
      component {
        ...on Recording {
          ${RECORDING_PROPS}
        }
        ...on SourceFile {
          ${SOURCE_FILE_PROPS}
        }
        ...on Video {
          ${COMMON_PROPS_COMPONENTS}
        }
        ...on Image {
          ${COMMON_PROPS_COMPONENTS}
        }
        ...on Text {
          ${COMMON_PROPS_COMPONENTS}
        }
      }
    }
  }
}
`;

export const GET_ALL_USERS_COMPONENTS = gql`
query allUserFiles(
  $personId: ID!
  $role: String!
  $isArchived: Boolean!
  $sharedComponentStatus: SharedComponentStatus
  ) {
  AllUserFiles(
    personId: $personId
    role: $role
    isArchived: $isArchived
    ) {
      id
      __typename
      isContributionOf {
        id
      }
      ...on Recording {
        ${GENERIC_PROPS}
        project {
          id
          title
          isArchived
        }
        referrer {
          id
          title
          isArchived
        }
        work {
          id
        }
        versions {
          ${GENERIC_PROPS}
          numberOfComments
          numberOfContributors
          numberOfSharedComponents(status: $sharedComponentStatus)
        }
       numberOfComments
       numberOfContributors
       numberOfSharedComponents(status: $sharedComponentStatus)
      }
      ...on SourceFile {
        ${GENERIC_PROPS}
        project {
          id
          title
          isArchived
        }
        referrer {
          id
          title
          isArchived
        }
        versions {
          ${GENERIC_PROPS}
          numberOfComments
          numberOfContributors
          numberOfSharedComponents(status: $sharedComponentStatus)
        }
       numberOfComments
       numberOfContributors
       numberOfSharedComponents(status: $sharedComponentStatus)
      }
      ...on Video {
        ${GENERIC_PROPS}
        project {
          id
          title
          isArchived
        }
        referrer {
          id
          title
          isArchived
        }
        work {
          id
        }
        versions {
          ${GENERIC_PROPS}
          numberOfComments
          numberOfContributors
          numberOfSharedComponents(status: $sharedComponentStatus)
        }
       numberOfComments
       numberOfContributors
       numberOfSharedComponents(status: $sharedComponentStatus)
      }
      ...on Image {
        ${GENERIC_PROPS}
        project {
          id
          title
          isArchived
        }
        referrer {
          id
          title
          isArchived
        }
        versions {
          ${GENERIC_PROPS}
          numberOfComments
          numberOfContributors
          numberOfSharedComponents(status: $sharedComponentStatus)
        }
       numberOfComments
       numberOfContributors
       numberOfSharedComponents(status: $sharedComponentStatus)
      }
      ...on Text {
        ${GENERIC_PROPS}
        project {
          id
          title
          isArchived
        }
        referrer {
          id
          title
          isArchived
        }
        versions {
          ${GENERIC_PROPS}
          numberOfComments
          numberOfContributors
          numberOfSharedComponents(status: $sharedComponentStatus)
        }
       numberOfComments
       numberOfContributors
       numberOfSharedComponents(status: $sharedComponentStatus)
      }
    }
  }
  `;

export const GET_ALL_USERS_COMPONENTS_LIMITED_PROPS = gql`
  query allUserFilesLimitedProps(
    $personId: ID!
    $role: String!
    $isArchived: Boolean!
  ) {
    AllUserFiles(personId: $personId, role: $role, isArchived: $isArchived) {
      id
      __typename
      isContributionOf {
        id
      }
      ... on Recording {
        __typename
        id
        title
        subtitle
        url
        version
        work {
          id
        }
        file {
          id
          uri
          fileName
          mimeType
          fileType
          size
          bitDepth
          samplingRate
        }
        project {
          id
          title
          isArchived
        }
        referrer {
          id
          title
          isArchived
        }
        isContributionOf {
          id
          role
          contributor {
            accountId
          }
        }
        versions {
          ... on Recording {
            id
            title
            subtitle
            url
            work {
              id
            }
            referrer {
              id
              title
              isArchived
            }
            project {
              id
              title
              isArchived
            }
          }
          ... on SourceFile {
            id
            title
            subtitle
            url
            referrer {
              id
              title
              isArchived
            }
            project {
              id
              title
              isArchived
            }
          }
        }
        groupInProject {
          componentGroup
        }
      }
      ... on SourceFile {
        __typename
        id
        title
        subtitle
        url
        version
        software
        file {
          id
          uri
          fileName
          mimeType
          fileType
          size
          bitDepth
          samplingRate
        }
        project {
          id
          title
          isArchived
        }
        referrer {
          id
          title
          isArchived
        }
        isContributionOf {
          id
          role
          contributor {
            accountId
          }
        }
        versions {
          ... on Recording {
            id
            title
            subtitle
            url
            version
            work {
              id
            }
            file {
              id
              uri
              fileName
              mimeType
              fileType
              size
              bitDepth
              samplingRate
            }
            referrer {
              id
              title
              isArchived
            }
            project {
              id
              title
              isArchived
            }
          }
          ... on SourceFile {
            id
            title
            subtitle
            url
            version
            file {
              id
              uri
              fileName
              mimeType
              fileType
              size
              bitDepth
              samplingRate
            }
            referrer {
              id
              title
              isArchived
            }
            project {
              id
              title
              isArchived
            }
          }
        }
        groupInProject {
          componentGroup
        }
      }
      ... on Video {
        ${COMMON_PROPS_COMPONENTS}
        url
        project {
          id
          title
          isArchived
        }
        referrer {
          id
          title
          isArchived
        }
        isContributionOf {
          id
          role
          contributor {
            accountId
          }
        }
        work {
          id
        }
        versions {
          ... on Video {
            ${COMMON_PROPS_COMPONENTS}
            referrer {
              id
              title
              isArchived
            }
            project {
              id
              title
              isArchived
            }
          }
        }
        groupInProject {
          componentGroup
        }
      }
      ... on Image {
        ${COMMON_PROPS_COMPONENTS}
        url
        project {
          id
          title
          isArchived
        }
        referrer {
          id
          title
          isArchived
        }
        isContributionOf {
          id
          role
          contributor {
            accountId
          }
        }
        versions {
          ... on Image {
            ${COMMON_PROPS_COMPONENTS}
            referrer {
              id
              title
              isArchived
            }
            project {
              id
              title
              isArchived
            }
          }
        }
        groupInProject {
          componentGroup
        }
      }
      ... on Text {
        ${COMMON_PROPS_COMPONENTS}
        url
        project {
          id
          title
          isArchived
        }
        referrer {
          id
          title
          isArchived
        }
        isContributionOf {
          id
          role
          contributor {
            accountId
          }
        }
        versions {
          ... on Text {
            ${COMMON_PROPS_COMPONENTS}
            referrer {
              id
              title
              isArchived
            }
            project {
              id
              title
              isArchived
            }
          }
        }
        groupInProject {
          componentGroup
        }
      }
    }
  }
`;

export const GET_ALL_DASHBOARD_COMPONENTS = gql`
query allDashboardComponents(
    $personId: ID! 
    $role: String!
    $componentArchived: Boolean!
    $projectArchived: Boolean!
    ) {
  AllUserDashboardFiles(
    personId: $personId
    role: $role
    componentArchived: $componentArchived
    projectArchived: $projectArchived
  ) 
  {
    ...on Recording {
      ${COMMON_PROPS_COMPONENTS}
      versions { 
          id
          version
          title
          file {
            uri,
            fileName,
          }
          __typename
      }
      work {
          id
      }
    }
    ...on SourceFile {
      ${COMMON_PROPS_COMPONENTS}
      versions { 
          id
          version
          title
          file {
            uri,
            fileName,
          }
          __typename
      }
    }
    ...on Video {
      ${COMMON_PROPS_COMPONENTS}
      versions { 
          id
          version
          title
          file {
            uri,
            fileName,
          }
          __typename
      }
    }
    ...on Text {
      ${COMMON_PROPS_COMPONENTS}
      versions { 
          id
          version
          title
          file {
            uri,
            fileName,
          }
          __typename
      }
    }
    ...on Image {
      ${COMMON_PROPS_COMPONENTS}
      versions { 
          id
          version
          title
          file {
            uri,
            fileName,
          }
          __typename
      }
    }
  }   
}
`;

export const GET_ALL_PROJECTS_COMPONENTS = gql`
query allProjectsComponents($projectIds: [ID]) {
  Projects(
    projectIds: $projectIds
    ) {
    id
    title
    components {
      componentGroup
      componentGroupOrderWeight
      componentOrderWeight
      component {
        ...on Recording {
          ${COMMON_PROPS_COMPONENTS}
          versions: versionsInProject { # versionsInProject is needed to prevent fetching versions that are actually imported components
          id
          version
          title
          file {
            uri,
            fileName,
          }
          __typename
        }
          work {
            id
          }
        }
        ...on SourceFile {
          ${COMMON_PROPS_COMPONENTS}
          versions: versionsInProject {  # versionsInProject is needed to prevent fetching versions that are actually imported components
            id
            version
            title
            file {
              uri,
              fileName,
            }
            __typename
          }
        }
        ...on Video {
          ${COMMON_PROPS_COMPONENTS}
          versions: versionsInProject {  # versionsInProject is needed to prevent fetching versions that are actually imported components
            id
            version
            title
            file {
              uri,
              fileName,
            }
            __typename
          }
          work {
            id
          }
        }
        ...on Image {
          ${COMMON_PROPS_COMPONENTS}
          versions: versionsInProject {  # versionsInProject is needed to prevent fetching versions that are actually imported components
            id
            version
            title
            file {
              uri,
              fileName,
            }
            __typename
          }
        }
        ...on Text {
          ${COMMON_PROPS_COMPONENTS}
          versions: versionsInProject {  # versionsInProject is needed to prevent fetching versions that are actually imported components
            id
            version
            title
            file {
              uri,
              fileName,
            }
            __typename
          }
        }
      }
    }
  }
}
`;

// RETURN TYPE: numbers of components with changed group name
export const UPDATE_COMPONENT_GROUP_NAME = gql`
  mutation updateComponentGroupName(
    $personId: ID!
    $projectId: ID!
    $componentIds: [String]!
    $componentGroup: String!
  ) {
    UpdateComponentGroupName(
      personId: $personId
      projectId: $projectId
      componentIds: $componentIds
      componentGroup: $componentGroup
    )
  }
`;

export const UPDATE_COMPONENT_GROUP_NAME_AND_ORDER = gql`
  mutation updateComponentGroupNameAndOrder(
    $personId: ID!
    $projectId: ID!
    $componentIds: [String]!
    $componentGroup: String!
    $componentGroupOrderWeight: Int!
    $componentOrderWeight: Int!
  ) {
    UpdateComponentGroupNameAndOrder(
      personId: $personId
      projectId: $projectId
      componentIds: $componentIds
      componentGroup: $componentGroup
      componentGroupOrderWeight: $componentGroupOrderWeight
      componentOrderWeight: $componentOrderWeight
    )
  }
`;

export const UPDATE_COMPONENTS_GROUP_ORDER_WEIGHT = gql`
  mutation updateComponentsGroupOrderWeight(
    $personId: ID!
    $projectId: ID!
    $componentIds: [String]!
    $componentGroupOrderWeight: Int!
  ) {
    UpdateComponentGroupOrderWeight(
      personId: $personId
      projectId: $projectId
      componentIds: $componentIds
      componentGroupOrderWeight: $componentGroupOrderWeight
    )
  }
`;

export const UNARCHIVE_COMPONENT = gql`
  mutation unarchiveComponent($personId: ID!, $projectId: ID!, $componentId: ID!) {
    UnarchiveComponent(personId: $personId, projectId: $projectId, componentId: $componentId)
  }
`;

export const TOGGLE_ARCHIVE_COMPONENT = gql`
  mutation toggleArchiveComponent(
    $componentId: ID!
    $personId: ID!
    $isArchived: Boolean!
  ) {
    ToggleArchiveComponent(
      personId: $personId
      isArchived: $isArchived
      componentId: $componentId
    )
  }
`;

export const CREATE_COMPONENT = gql`
mutation CreateComponent (
  $partyId: ID!,
  $projectId: ID,
  $label: String!
  $componentInput: ComponentInput, 
  $fileInput: FileInput,
  $componentGroup: String,
  $componentGroupOrderWeight: Int, 
  $componentOrderWeight: Int
  $fullFileKey: String!
) {
  CreateComponent(
    partyId: $partyId,
    projectId: $projectId,
    label: $label
    componentInput: $componentInput,
    fileInput: $fileInput
    componentGroup: $componentGroup
    componentGroupOrderWeight: $componentGroupOrderWeight
    componentOrderWeight: $componentOrderWeight
    fullFileKey: $fullFileKey
  ) 
  {
    ${COMMON_PROPS_COMPONENTS}
    ${COMPONENT_CONTRIBUTIONS_PROPS}
    ${COMPONENT_IS_VERSION_PROPS}
    ${CONTRIBUTOR_MIN_PROPS}
  }
}
`;

export const CREATE_VERSION_OF_COMPONENT = gql`
mutation CreateVersionOfComponent(
  $partyId: ID!,
  $projectId: ID,
  $label: String!,
  $componentInput: ComponentInput, 
  $fileInput: FileInput,
  $componentGroup: String,
  $componentGroupOrderWeight: Int, 
  $componentOrderWeight: Int,
  $parentComponentId: ID!
  $fullFileKey: String!
  )
{
  CreateVersionOfComponent(
    partyId: $partyId,
    projectId: $projectId,
    label: $label,
    componentInput: $componentInput,
    fileInput: $fileInput,
    componentGroup: $componentGroup,
    componentGroupOrderWeight: $componentGroupOrderWeight
    componentOrderWeight: $componentOrderWeight
    parentComponentId: $parentComponentId
    fullFileKey: $fullFileKey
    )
  {
    ${COMMON_PROPS_COMPONENTS}
    ${COMPONENT_CONTRIBUTIONS_PROPS}
    ${COMPONENT_IS_VERSION_PROPS}
    ${CONTRIBUTOR_MIN_PROPS}
  }
}
`;

export const CREATE_COMPONENT_WITH_WORK = gql`
mutation createComponentWithWork (
  $partyId: ID!,
  $projectId: ID,
  $label: String!
  $componentInput: ComponentInput, 
  $fileInput: FileInput,
  $componentGroup: String,
  $componentGroupOrderWeight: Int, 
  $componentOrderWeight: Int
  $fullFileKey: String!
) {
  CreateComponentWithWork(
    partyId: $partyId,
    projectId: $projectId,
    label: $label
    componentInput: $componentInput,
    fileInput: $fileInput
    componentGroup: $componentGroup
    componentGroupOrderWeight: $componentGroupOrderWeight
    componentOrderWeight: $componentOrderWeight
    fullFileKey: $fullFileKey
  ) 
  {
    ...on Recording {
      ${CONTRIBUTOR_MIN_PROPS}
      ${COMMON_PROPS_COMPONENTS}
      ${COMPONENT_CONTRIBUTIONS_PROPS}
      ${COMPONENT_IS_VERSION_PROPS}
      work {
        id
      }
      uploader {
        id 
        accountId
      }
    }
    ...on Video {
      ${CONTRIBUTOR_MIN_PROPS}
      ${COMMON_PROPS_COMPONENTS}
      ${COMPONENT_CONTRIBUTIONS_PROPS}
      ${COMPONENT_IS_VERSION_PROPS}
      work {
        id
      }
      uploader {
        id 
        accountId
      }
    }
  }
}
`;

export const CREATE_VERSION_OF_COMPONENT_WITH_WORK = gql`
mutation CreateVersionOfComponentWithWork (
  $partyId: ID!,
  $projectId: ID,
  $label: String!
  $componentInput: ComponentInput, 
  $fileInput: FileInput,
  $componentGroup: String,
  $componentGroupOrderWeight: Int, 
  $componentOrderWeight: Int
  $parentComponentId: ID!
  $latestVersionComponentId: ID!
  $workId: ID!
  $fullFileKey: String!
) {
  CreateVersionOfComponentWithWork(
    partyId: $partyId,
    projectId: $projectId,
    label: $label
    componentInput: $componentInput,
    fileInput: $fileInput
    componentGroup: $componentGroup
    componentGroupOrderWeight: $componentGroupOrderWeight
    componentOrderWeight: $componentOrderWeight
    parentComponentId: $parentComponentId
    latestVersionComponentId: $latestVersionComponentId
    workId: $workId
    fullFileKey: $fullFileKey
  ) 
  {
    ...on Recording {
      ${CONTRIBUTOR_MIN_PROPS}
      ${COMMON_PROPS_COMPONENTS}
      ${COMPONENT_CONTRIBUTIONS_PROPS}
      ${COMPONENT_IS_VERSION_PROPS}
      work {
        id
      }
      uploader {
        id 
        accountId
      }
    }
    ...on Video {
      ${CONTRIBUTOR_MIN_PROPS}
      ${COMMON_PROPS_COMPONENTS}
      ${COMPONENT_CONTRIBUTIONS_PROPS}
      ${COMPONENT_IS_VERSION_PROPS}
      work {
        id
      }
      uploader {
        id 
        accountId
      }
    }
  }
}
`;

export const UPDATE_COMPONENT = gql`
mutation UpdateComponent(
  $input: UpdateComponentInput!
  $label: String!
  )
  {
  UpdateComponent(
    input: $input
    label: $label
    ) 
    {
      ...on Video {
        ${COMMON_PROPS_COMPONENTS}
        ${COMPONENT_CONTRIBUTIONS_PROPS}
        ${COMPONENT_IS_VERSION_PROPS}
        versionsInProject {
          ${COMMON_PROPS_COMPONENTS}
          versionsInProject {
            id
          }
        }
        work {
          id
        }
      }
      ...on Recording {
        ${COMMON_PROPS_COMPONENTS}
        ${COMPONENT_CONTRIBUTIONS_PROPS}
        ${COMPONENT_IS_VERSION_PROPS}
        versionsInProject {
          ${COMMON_PROPS_COMPONENTS}
          versionsInProject {
            id
          }
        }
        work {
          id
        }
      }
      ...on SourceFile {
        ${COMMON_PROPS_COMPONENTS}
        ${COMPONENT_CONTRIBUTIONS_PROPS}
        ${COMPONENT_IS_VERSION_PROPS}
        versionsInProject {
          ${COMMON_PROPS_COMPONENTS}
          versionsInProject {
            id
          }
        }
      }
      ...on Image {
        ${COMMON_PROPS_COMPONENTS}
        ${COMPONENT_CONTRIBUTIONS_PROPS}
        ${COMPONENT_IS_VERSION_PROPS}
        versionsInProject {
          ${COMMON_PROPS_COMPONENTS}
          versionsInProject {
            id
          }
        }
      }
      ...on Text {
        ${COMMON_PROPS_COMPONENTS}
        ${COMPONENT_CONTRIBUTIONS_PROPS}
        ${COMPONENT_IS_VERSION_PROPS}
        versionsInProject {
          ${COMMON_PROPS_COMPONENTS}
          versionsInProject {
            id
          }
        }
      }
    }
  }
`;

export const GET_COMPONENT_COMMENTS = gql`
query ComponentComments(
  $componentId: ID!
  ) {
  GetComponent(
    componentId: $componentId
    ) 
    {
      id
      ${COMPONENT_COMMENTS_PROPS}
    }
  }
`;

export const GET_COMPONENT_CONTRIBUTORS = gql`
query ComponentContributors(
  $componentId: ID!
  ) {
  GetComponent(
    componentId: $componentId
    ) 
    {
      id
      ${COMPONENT_CONTRIBUTIONS_PROPS}
    }
  }
`;

export const GET_COMPONENT_SHARED_COMPONENTS = gql`
query ComponentSharedComponents(
  $componentId: ID!
  ) {
  GetComponent(
    componentId: $componentId
    ) 
    {
      id
      ${COMPONENT_SHARED_PROPS}
    }
  }
`;
